import {useState} from 'react';
import {useResizable} from './customHooks';

const withResizable = (WrappedComponent) => {
  function AddedOnResize(props) {
    const [windowSize, setWindowSize] = useState();

    useResizable(setWindowSize);

    // eslint-disable-next-line react/jsx-props-no-spreading
    return <WrappedComponent windowSize={windowSize} {...props} />;
  }

  return AddedOnResize;
};

export default withResizable;
